import { css, mq, spacing, styled, Text } from '@thg-commerce/enterprise-theme'
import { Button, SafeHtml } from '@thg-commerce/gravity-elements'
import { ButtonState } from '@thg-commerce/gravity-elements/Button'

import { LoyaltyStatusStyleInterface } from './LoyaltyStatusBar'

export const Container = styled.div`
  margin: ${spacing(4)} 0;
  border: solid 1px ${(props) => props.theme.colors.palette.greys.light};
  width: 100%;
  text-align: center;
  padding-top: ${spacing(1)};
`

export const TopContainer = styled.div`
  padding: ${spacing(2)} ${spacing(2)} ${spacing(1)} ${spacing(2)};
  display: flex;
  flex-direction: column;
`

export const BottomContainer = styled.div`
  padding: ${spacing(2)};
  display: flex;
  flex-direction: column;
  gap: ${spacing(2)};
`

export const ProgressBarContainer = styled.div`
  padding: ${spacing(0)} ${spacing(3)} ${spacing(0)} ${spacing(3)};
  width: 100%;

  ${(props) => mq(props.theme.breakpointUtils.map, 'sm')} {
    padding: ${spacing(0)} ${spacing(5)} ${spacing(0)} ${spacing(1)};
  }
`

export const StatusTitle = styled.p`
  ${Text('large1', 'alternate')};
  margin-bottom: ${spacing(0.75)};
`

export const StatusInfo = styled(SafeHtml)`
  ${Text('bodyText', 'default')};
`

const loyaltyButtonStateProperties = (state: ButtonState) => (props) => css<{
  statusButtonStyle?: LoyaltyStatusStyleInterface
}>`
  ${Text('bodyText', props.statusButtonStyle?.[state].button.text.style)}
  background-color: ${props.statusButtonStyle?.[state].button.backgroundColor};
  border: ${props.statusButtonStyle?.[state].button.border.width} solid
    ${props.statusButtonStyle?.[state].button.border.color};
  color: ${props.statusButtonStyle?.[state].button.text.color};
  text-decoration: ${props.statusButtonStyle?.[state].button.text
    .textDecoration};
  box-shadow: ${props.statusButtonStyle?.[state].button.boxShadow.shadowX}
    ${props.statusButtonStyle?.[state].button.boxShadow.shadowY}
    ${props.statusButtonStyle?.[state].button.boxShadow.shadowBlur}
    ${props.statusButtonStyle?.[state].button.boxShadow.shadowSpread}
    ${props.statusButtonStyle?.[state].button.boxShadow.shadowColor};
`

const customStateStyle = css`
  ${loyaltyButtonStateProperties(ButtonState.Default)}

  &:hover {
    ${loyaltyButtonStateProperties(ButtonState.Hover)}
  }

  &:focus {
    ${loyaltyButtonStateProperties(ButtonState.Focus)}
  }

  &:active {
    ${loyaltyButtonStateProperties(ButtonState.Active)}
  }
`

export const StyledStatusButton = styled(Button)<{
  statusButtonStyle?: LoyaltyStatusStyleInterface
}>`
  > button {
    ${(props) => props.statusButtonStyle && customStateStyle}
  }
`
